PJQ.compression = {
	encode: {
		delta(values) {
			values = values.sort(function (a, b) {
				return a - b;
			});

			return values.reduce(function (state, value) {
				let diff = value - state.lastValue;
				state.encoded.push(isNaN(diff) ? value : diff);
				state.lastValue = value;
				return state;
			}, {
				encoded: []
			}).encoded;
		},
		runLength(values) {
			let len = _.size(values);
			return values.reduce(function (state, value, index) {
				//if this is the last value in array, we need to do things a bit differently
				if (index === len - 1) {
					if (state.lastValue !== value) {
						// if the last value doesn't match this one, add it to the result
						if (!isNaN(state.lastValue)) {
							state.encoded.push(state.multiple > 1 ? state.multiple.toString() + '_' + state.lastValue.toString() : state.lastValue.toString());
							state.multiple = 1;
						}
						state.encoded.push(value.toString());
					}
					else {
						state.multiple++;
						state.encoded.push(state.multiple.toString() + '_' + value.toString());
					}
				}
				else {
					if (state.lastValue === value) {
						// if the last value matches this one, just increment the counter
						state.multiple++;
					}
					else if (!isNaN(state.lastValue)) {
						// if the last value doesn't match this one AND this isn't the first iteration
						// add the multiple+lastValue or lastValue (if multiple === 1)
						state.encoded.push(state.multiple > 1 ? state.multiple.toString() + '_' + state.lastValue.toString() : state.lastValue.toString());
						state.multiple = 1;
					}
				}
				state.lastValue = value;
				return state;
			}, {
				encoded: [],
				multiple: 1
			}).encoded;
		}
	},
	decode: {}
};